import { ArrowRightIcon } from '@heroicons/react/24/outline'

const CardActions = ({ actions = [] }) => (
    <div className="mb-8">
        <p className="text-[10px] font-semibold uppercase tracking-widest text-gray-400 mb-3">Acesso Rápido</p>
        <div className={`grid gap-4 ${actions.length > 2 ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4' : 'grid-cols-1 sm:grid-cols-2'}`}>
            {actions.map((action) => {
                const Icon = action.icon
                return (
                    <button
                        key={action.id}
                        onClick={() => window.location.href = action.href}
                        className="group bg-white border border-gray-100 hover:border-brand-yellow rounded-2xl p-5 text-left shadow-sm hover:shadow-md transition-all duration-200"
                    >
                        <div className="flex items-start justify-between mb-4">
                            <div className="p-2.5 bg-brand-yellow/15 rounded-xl">
                                <Icon className="w-5 h-5 text-gray-900" />
                            </div>
                            <ArrowRightIcon className="w-4 h-4 text-gray-300 group-hover:text-brand-yellow group-hover:translate-x-0.5 transition-all duration-200" />
                        </div>
                        <h3 className="text-sm font-semibold text-gray-900 mb-1">{action.title}</h3>
                        <p className="text-xs text-gray-400 line-clamp-2">{action.description}</p>
                    </button>
                )
            })}
        </div>
    </div>
)

export default CardActions
